export default __webpack_public_path__ + "static/media/FacebookQRCodeUS.343719cd.jpeg";